import { useEffect } from "react";

/**
 * Sets document.title + meta description + canonical + OG tags per page.
 * Idempotent: reuses existing <meta> nodes if present.
 */
export default function useSeo({ title, description, path = "/", ogImage }) {
  useEffect(() => {
    if (title) document.title = title;

    const upsertMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const upsertLink = (rel, href) => {
      if (!href) return;
      let el = document.head.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }
    if (title) {
      upsertMeta("property", "og:title", title);
      upsertMeta("name", "twitter:title", title);
    }

    const origin = window.location.origin;
    const url = origin + path;
    upsertMeta("property", "og:url", url);
    upsertLink("canonical", url);

    if (ogImage) {
      const absImage = ogImage.startsWith("http") ? ogImage : origin + ogImage;
      upsertMeta("property", "og:image", absImage);
      upsertMeta("name", "twitter:image", absImage);
    }
  }, [title, description, path, ogImage]);
}
